module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }, [(_vm.formData.status == 1) ? _c('img', {
    attrs: {
      "src": require("../../../assets/images/icon-order-delivery.png"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/images/icon-order-done.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.formData.status == 1 ? '待审核' : '审核成功'))])]), _vm._v(" "), _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "name": "radio",
      "label": "类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.leixing),
            callback: function($$v) {
              _vm.$set(_vm.formData, "leixing", $$v)
            },
            expression: "formData.leixing"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "2023年‘奔跑吧·少年’全国啦啦操大课间展示活动"
          }
        }, [_vm._v("2023年‘奔跑吧·少年’全国啦啦操大课间展示活动")])], 1)]
      },
      proxy: true
    }], null, false, 2125736883)
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入准确的单位全称'
      }],
      "label": "单位名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入准确的单位全称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入邮寄联系人及电话'
      }],
      "error-message-align": "right",
      "label": "邮寄联系人及电话",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮寄联系人及电话"
    },
    model: {
      value: (_vm.formData.express_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "express_name", $$v)
      },
      expression: "formData.express_name"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("啦啦操推广大使")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "个人姓名（限1人）",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("联系人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入联系人姓名'
      }],
      "error-message-align": "right",
      "label": "联系人姓名",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人姓名"
    },
    model: {
      value: (_vm.formData.contactsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsname", $$v)
      },
      expression: "formData.contactsname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入联系人手机'
      }],
      "error-message-align": "right",
      "label": "联系人手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人手机"
    },
    model: {
      value: (_vm.formData.contactsphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsphone", $$v)
      },
      expression: "formData.contactsphone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.showTemplate = true
      }
    }
  }, [_vm._v("\n        申报优秀参与人员\n      ")])], 1)], 1), _vm._v(" "), (_vm.formData.cert_url && _vm.formData.cert_url.url && false) ? _c('div', {
    staticClass: "cert-li"
  }, [_c('van-divider', [_vm._v("电子证书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.formData.cert_url.url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cert-button"
  }, [(!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存\n      ")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.appDownload(_vm.formData.cert_url.filename, _vm.formData.cert_url.url)
      }
    }
  }, [_vm._v("点击下载\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "导入模板信息"
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("复制下面的链接，用电脑端打开，进行批量导入操作")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.formData.share),
      expression: "formData.share",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("导入模板链接地址：" + _vm._s(_vm.formData.share) + "\n      "), _c('div', {
    staticClass: "small-button"
  }, [_vm._v("复制")])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6808f694","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/dakejian/DakejianApplySuccess.vue
// module id = 2451
// module chunks = 0